function checkoutIpxx() {
  const isIOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
  if (!isIOS) return false;

  const screenHeight = window.screen.height;
  const screenWidth = window.screen.width;
  const iphonexxAry = [
    {
      // x, xs, 11pro, 12mini
      width: 375,
      height: 812,
    },
    {
      // xsm, 11pm, xr, 11
      width: 414,
      height: 896,
    },
    {
      // 12, 12p
      width: 390,
      height: 844,
    },
    {
      // 12pm
      width: 428,
      height: 926,
    },
  ];

  const isIphonexx = iphonexxAry.find((item) => {
    return screenWidth === item.width && screenHeight === item.height;
  });
  return !!isIphonexx;
}

export default checkoutIpxx;
